<template>
  <div class="row">
    <div class="ml-1 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <p class="card-category">
        {{ totalRows ? totalRows : paginationData.total }} {{  $t("pagination.entries") }}
      </p>
    </div>
    <div
      class="col-2"
    >
      <el-select
        class="select-primary mb-3 pagination-select"
        v-model="page.size"
        placeholder="Per page"
        @input="updateSize"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>

    <div class="col"></div>
    <div class="pr-3">

      <ul class="pagination pagination-no-border" :class="paginationClass">

        <li
          class="page-item prev-page"
          v-if="showArrows"
          :class="{ disabled: paginationData.current_page === 1 }"
        >
          <a class="page-link" aria-label="Previous" @click="firstPage">
            <i class="tim-icons icon-double-left" aria-hidden="true"></i>
          </a>
        </li>
        <li
          class="page-item prev-page"
          v-if="showArrows"
          :class="{ disabled: paginationData.current_page === 1 }"
        >
          <a class="page-link" aria-label="Previous" @click="prevPage">
            <i class="tim-icons icon-minimal-left" aria-hidden="true"></i>
          </a>
        </li>
        <li v-if="!isFirst()">...</li>
        <li
          class="page-item"
          v-for="(item, key) in pages"
          v-bind:key="key"
          :class="{ active: item.isDisabled }"
        >
          <a class="page-link" @click="updatePagination(item.name)">{{ item.name }}</a>
        </li>
        <li v-if="!isLast()">...</li>
        <li
          v-if="showArrows"
          class="page-item page-pre next-page"
          :class="{ disabled: paginationData.current_page === paginationData.last_page }"
        >
          <a class="page-link" aria-label="Next" @click="nextPage">
            <i class="tim-icons icon-minimal-right" aria-hidden="true"></i>
          </a>
        </li>
        <li
          v-if="showArrows"
          class="page-item page-pre next-page"
          :class="{ disabled: paginationData.current_page === paginationData.last_page }"
        >
          <a class="page-link" aria-label="Next" @click="lastPage">
            <i class="tim-icons icon-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import ObjectHelper from "src/util/objectHelper";
  import { Select, Option } from 'element-ui';
  import vuex from "src/vuex"
  import { isEmpty } from "lodash";

  export default {
    name: 'base-pagination',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      let defaultRows = this.defaultRows;
      return {
        pagination: {
          perPage: 20,
          currentPage: 1,
          perPageOptions: [10, 20, 50],
          total: 0
        },
        page: {},
        defaultPagination: {
          size: defaultRows,
          number: 1
        }
      }
    },
    props: {
      totalRows: {
        type: Number,
        required: true
      },
      defaultRows: {
        type: Number,
        default: () => 10
      },
      paginationData: {
        required: true
      },
      type: {
        type: String,
        default: 'primary',
        validator: value => {
          return [
            'default',
            'primary',
            'danger',
            'success',
            'warning',
            'info'
          ].includes(value);
        }
      },
      showArrows: {
        type: Boolean,
        default: true
      },
      limit: {
        type: Number,
        required: false,
        default: 7
      },
      useVuex: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      if (this.useVuex) this.retrievePaginationVuex();
      else this.setDataFromQueryString();
    },
    computed: {
      size() {
        return parseInt(this.page.size);
      },
      paginationClass() {
        return `pagination-${this.type}`;
      },
      startPage() {
        // When on the first page
        if (this.paginationData.current_page === 1) {
          return 1;
        }
        // When on the last page
        if (this.paginationData.current_page === this.paginationData.last_page) {
          if ((this.paginationData.last_page - this.limit + 1) < 1) {
            return 1;
          } else {
            return this.paginationData.last_page - this.limit + 1;
          }
        }
        // When in between
        return this.paginationData.current_page - 1;
      },
      pages() {
        const range = [];
        for (let i = this.startPage;
             i <= Math.min(this.startPage + this.limit - 1, this.paginationData.last_page);
             i+= 1 ) {
          range.push({
            name: i,
            isDisabled: i === this.paginationData.current_page
          });
        }

        return range;
      },
    },
    methods: {
      setDataFromQueryString() {
        this.page = Object.assign(
          {},
          this.defaultPagination,
          this.$route.query.page
        );
      },
      updatePagination(pageNumber) {
        this.page.number = pageNumber;
        this.updateUrl();
        this.emitEvent();
      },
      updateUrl() {
        let query = ObjectHelper.clone(this.$route.query);
        query.page = {
          size: this.page.size,
          number: this.page.number
        };

        if (this.useVuex)
          this.storePaginationVuex(query.page);

        this.$router.replace({query});
      },
      emitEvent() {
        this.$emit(
          "update:pagination",
          ObjectHelper.removeEmptyFields(this.page)
        );
      },
      range(min, max) {
        let arr = [];
        for (let i = min; i <= max; i++) {
          arr.push(i);
        }
        return arr;
      },

      nextPage() {
        if (this.paginationData.current_page < this.paginationData.last_page) {
          this.updatePagination(this.paginationData.current_page + 1);
        }
      },
      prevPage() {
        if (this.paginationData.current_page > 1) {
          this.updatePagination(this.paginationData.current_page - 1);
        }
      },
      firstPage() {
        this.updatePagination(1);
      },
      lastPage() {
        this.updatePagination(this.paginationData.last_page);
      },
      isLast() {
        return this.paginationData.current_page === this.paginationData.last_page;
      },
      isFirst() {
        return this.paginationData.current_page === 1;
      },
      updateSize(){
        this.page.number = 1;
        this.updateUrl();
      },
      storePaginationVuex(data) {
        const page = ObjectHelper.removeEmptyFields(data);
        vuex.dispatch("setPage", ObjectHelper.clone(page));
      },
      retrievePaginationVuex() {
        const page = vuex.getters.getPage;
        page.reset = false;

        if (!isEmpty(page)) {
          this.page = Object.assign(
            {},
            this.defaultPagination,
            page
          );

          this.updateUrl();
        }
      }
    }
  };
</script>
